import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';

const updateContactsStyles = {
    legend: css({
        width: '44px',
        height: '44px',
        backgroundColor: '#ffffff',
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        color: '#004FC6',
        fontSize: '18px',
        fontWeight: 600,
        cursor: 'pointer',
    }),
    contentWrapper: css({
        marginBottom: '50px',
        '@media (min-width: 800px)': {
            padding: '20px 0',
            marginBottom: '0',
        }
    }),
    menuHeader: css({
        fontSize: '16px',
        fontWeight: 700,
        margin: 0,
        textAlign: 'center',
        width: '100%',
        marginBottom: '20px',
    }),
    menuDescription: css({
        fontSize: '14px',
        color: '#000000',
        marginBottom: '20px',
        textAlign: 'center',
    }),
    menuList: css({
        textAlign: 'center',
        transition: '0.3s',
        overflow: 'hidden',
        zIndex: Z_INDEX.LEGEND_DESKTOP,
        backgroundColor: '#ffffff',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        width: '100%',
        padding: '10px 15px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    }),
    menuDesktopBackdrop: css({
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000000CC',
        zIndex: Z_INDEX.OVERLAY_BACKDROP,
    }),
    menuDesktopContent: css({
        position: 'relative',
        width: '100vw',
        height: '100vh',
        zIndex: Z_INDEX.OVERLAY_BACKDROP,
    }),
    menuListDesktop: css({
        position: 'absolute',
        bottom: '50%',
        right: "50%",
        transform: 'translate(50%, 50%)',
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
        borderRadius: 8,
        width: '375px',
        padding: '8px 16px',
    }),
    legendImage: css({
        width: '100%',
    }),
    actionWrapper: css({
        display: 'flex',
        justifyContent: 'space-between',
        gap: '20px',
        alignItems: 'center',
        width: '100%',
    }),
};

export default updateContactsStyles;
